var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBalzer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 708.4 257.5",
    style: {
      enableBackground: "new 0 0 708.4 257.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0085CB;}\n\t.st1{display:none;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#E5007D;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#E5007D;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:12.0233,12.0233;}\n\t.st5{fill:none;stroke:#E5007D;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:12.1016,12.1016;}\n\t.st6{fill:none;stroke:#E5007D;stroke-width:0.5;stroke-miterlimit:10;stroke-dasharray:11.9666,11.9666;}\n\t.st7{display:inline;fill:none;stroke:#E5007D;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st8{font-family:'MyriadPro-Regular';}\n\t.st9{font-size:12px;}\n\t.st10{opacity:0.4;fill:#868786;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.1,75.6 351.1,100.6 385.2,100.6 355.5,151.2 433.2,151.2 433.2,126.2 405.2,126.2 434.5,75.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.3,105.5l8.1,14.1h-16.2L222.3,105.5z M239.6,75.6H205l0,0l-44.3,75.6h35.2l7.5-13.1h37.7l7.5,13.1h35.2L239.6,75.6 L239.6,75.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.7,75.6 275.7,125.9 290.5,151.2 348.9,151.2 363.6,126.2 304.7,126.2 304.7,75.6  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.4,132.8h-24.8v-11.9h24.8c5.9,0,7.7,2.6,7.7,5.9C137.1,130.2,135.3,132.8,129.4,132.8 M104.6,94h21.8 c6,0,7.4,2,7.4,4.8c0,3-1.4,5-7.4,5h-21.8C104.6,103.8,104.6,94,104.6,94z M168.8,126.1c-0.2-5.6-3.5-14.2-12.9-16.7v-0.2 c5.7-2.2,9-8,9-14.7c0-12.1-6.9-18.8-22.3-18.8h-67v75.6h63.7c6.7,0,12.1-0.9,16.3-2.6L168.8,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.4,108.7H556V94.6h22c4.9,0,8.6,1.4,8.6,7C586.6,106.4,584.2,108.7,578.4,108.7 M615.1,126c-1.2-2.1-5.6-11.3-9.7-12.1 v-0.2c8.6-2.5,12.7-10.1,12.7-17.1c0-8.2-4.6-15.5-10.2-18.2c-4.1-2-9.2-2.7-17.8-2.7H527V131l11.8,20.3H556v-23.6h22.4 c5.5,0,7,3.1,10.7,9.5c3.3,5.8,8.1,14.2,8.1,14.2h32.4L615.1,126z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.6,169.9h-9.2v2.9h5.3c-0.6,3.1-2.5,4.9-6.5,4.9c-3.3,0-6.5-1.8-6.5-6.8c0-4.1,1.9-7.1,6.7-7.1c2.5,0,4.9,1.1,5.6,3.6 h4.3c-0.4-3.7-4.1-6.6-9.8-6.6c-7.6,0-10.9,4.6-10.9,9.9c0,5.3,3.1,9.9,11,9.9c2.9,0,5.6-1.1,7.1-3l0.6,2.4h2.3V169.9z M419,180.2 h3.6v-6.7c0-3.2,2.6-4.2,4.4-4.2c0.6,0,1.3,0,2.3,0.3V166c-0.5-0.1-0.9-0.1-1.4-0.1c-2.8,0-4.3,1.5-5.3,3.1h-0.1v-2.7H419V180.2z  M431.2,175.5c0,4.1,2.9,5.1,5.9,5.1c2.5,0,4.3-1,5.5-2.5h0.1v1.9h3.6v-13.9h-3.6v7.6c0,3-2.6,4-4.2,4c-3.1,0-3.6-1.6-3.6-3.7v-7.9 h-3.6L431.2,175.5L431.2,175.5z M457.3,168.7c3.4,0,4.7,2.3,4.7,4.6c0,2.4-1.3,4.6-4.7,4.6c-3.4,0-4.7-2.3-4.7-4.6 C452.7,171,454,168.7,457.3,168.7 M449.2,180.2h3.6v-1.9h0.1c0.3,0.8,2.4,2.4,5.3,2.4c5.3,0,7.6-3.9,7.6-7.4s-2.3-7.4-7.6-7.4 c-2.2,0-4.3,0.7-5.3,2.4h-0.1v-7.1h-3.6V180.2z M484.6,174.1v-0.5c0-4.1-2.4-7.9-8.5-7.9c-4.9,0-8.4,3-8.4,7.6 c0,3.7,2.3,7.4,8.6,7.4c5.3,0,7.2-3.1,8-4.6h-3.9c-0.7,1.2-1.8,2-4.2,2c-3.6,0-4.7-2.4-4.7-3.9h13.1V174.1z M471.5,171.8 c0.6-2.8,3-3.6,4.7-3.6c1.8,0,4.3,0.8,4.7,3.6H471.5z M487.1,180.2h3.6v-7.5c0-3,2.4-4,4.3-4c3,0,3.5,1.7,3.5,3.2v8.3h3.6v-9.5 c0-3.8-2.9-4.8-5.9-4.8c-2.5,0-4.3,1-5.5,2.5h-0.1v-2.1H487v13.9H487.1z M504.4,175.8c0.1,4.3,4.8,4.9,7.8,4.9 c4.3,0,7.7-1.2,7.7-4.8c0-3.2-3-3.7-7.6-4.3c-3.5-0.5-3.8-0.7-3.8-1.8c0-0.7,1.1-1.6,3.2-1.6c1.2,0,3.7,0.2,3.9,2.3h3.8 c-0.2-4.5-5.4-4.8-7.5-4.8c-2.3,0-7,0.5-7,4.5c0,3.2,2.3,3.7,6.6,4.3c3.9,0.5,4.5,0.9,4.5,2c0,1.3-2,1.8-3.8,1.8 c-1.3,0-3.7-0.3-3.8-2.4L504.4,175.8L504.4,175.8z M526.9,179.9l-0.8,1.7c-0.4,0.9-1.1,1.1-2.1,1.1c-0.8,0-1.5,0-1.8-0.1v2.8 c0.7,0,1.7,0.1,2.3,0.1c3,0,3.9-0.4,5-2.8l7.6-16.4h-3.9l-4.4,10l-4.5-10h-3.9L526.9,179.9z M537.5,175.8c0.1,4.3,4.8,4.9,7.8,4.9 c4.3,0,7.7-1.2,7.7-4.8c0-3.2-3-3.7-7.6-4.3c-3.5-0.5-3.8-0.7-3.8-1.8c0-0.7,1.1-1.6,3.2-1.6c1.2,0,3.7,0.2,3.9,2.3h3.8 c-0.2-4.5-5.4-4.8-7.5-4.8c-2.3,0-7,0.5-7,4.5c0,3.2,2.3,3.7,6.6,4.3c3.9,0.5,4.5,0.9,4.5,2c0,1.3-2,1.8-3.8,1.8 c-1.3,0-3.7-0.3-3.8-2.4L537.5,175.8L537.5,175.8z M556.4,176.3c0,2.6,0.3,4.2,4.8,4.2c1.1,0,1.8-0.1,2.8-0.2v-2.6 c-0.9,0-1.7,0.1-2.6,0.1c-1.2,0-1.3-0.9-1.3-2.5v-6.4h3.8v-2.6H560V162h-3.6v4.3h-2.9v2.6h2.9V176.3z M582.4,174.1v-0.5 c0-4.1-2.4-7.9-8.5-7.9c-4.9,0-8.4,3-8.4,7.6c0,3.7,2.3,7.4,8.6,7.4c5.3,0,7.2-3.1,8-4.6h-3.9c-0.7,1.2-1.8,2-4.2,2 c-3.6,0-4.7-2.4-4.7-3.9h13.1V174.1z M569.3,171.8c0.6-2.8,3-3.6,4.7-3.6c1.8,0,4.3,0.8,4.7,3.6H569.3z M595.7,180.2h3.6v-7.8 c0-3,2.5-3.8,3.8-3.8c3.2,0,3.4,1.8,3.4,3.2v8.3h3.6v-9.2c0-4.3-3.3-5-5.5-5c-2.9,0-4.8,1.3-5.6,2.6c-1-2.3-3.3-2.6-4.9-2.6 c-2.5,0-4.3,1-5.5,2.5h-0.1v-2.1h-3.6v13.9h3.6v-7.8c0-3,2.5-3.8,3.8-3.8c3.2,0,3.4,1.8,3.4,3.2V180.2z M629.6,174.1v-0.5 c0-4.1-2.4-7.9-8.5-7.9c-4.9,0-8.4,3-8.4,7.6c0,3.7,2.3,7.4,8.6,7.4c5.3,0,7.2-3.1,8-4.6h-3.9c-0.7,1.2-1.8,2-4.2,2 c-3.6,0-4.6-2.4-4.7-3.9h13.1V174.1z M616.5,171.8c0.6-2.8,3-3.6,4.6-3.6c1.8,0,4.3,0.8,4.7,3.6H616.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.2,86.6h3c2,0,3.3-0.2,3.3-2.3c0-1.8-2-2.1-3.5-2.1h-2.8V86.6z M630.8,79.4h6.5c4.3,0,6.7,1.3,6.7,5 c0,3.2-2,4.4-4.5,4.5l4.5,7.4h-3.5l-4.1-7.3h-2.1v7.3h-3.4V79.4z M636.8,100c6.3,0,11.5-5,11.5-11.9c0-6.9-5.1-11.9-11.5-11.9 s-11.5,5-11.5,11.9C625.5,94.9,630.5,100,636.8,100 M636.8,72.8c8.3,0,15.6,6,15.6,15.1c0,9.3-7.3,15.2-15.6,15.2 s-15.6-6-15.6-15.2C621.3,78.8,628.6,72.8,636.8,72.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "438.8,75.7 438.8,151.2 532.2,151.2 520.6,131.1 467.8,131.1 467.8,122.8 518.5,122.8 518.5,104.1 467.8,104.1  467.8,95.8 521.4,95.8 521.4,75.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "75.6,156.9 75.6,181.9 372.6,181.9 387.2,156.9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ma\\xDFe",
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.3,
    y1: 75.7,
    x2: 13.3,
    y2: 75.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 25.3,
    y1: 75.7,
    x2: 620.4,
    y2: 75.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 626.5,
    y1: 75.7,
    x2: 632.5,
    y2: 75.7
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 59.7,
    y1: 151.2,
    x2: 65.7,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 77.7,
    y1: 151.2,
    x2: 672.9,
    y2: 151.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 678.9,
    y1: 151.2,
    x2: 684.9,
    y2: 151.2
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.3,
    y1: 156.9,
    x2: 13.3,
    y2: 156.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 25.3,
    y1: 156.9,
    x2: 620.4,
    y2: 156.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 626.5,
    y1: 156.9,
    x2: 632.5,
    y2: 156.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 7.3,
    y1: 181.9,
    x2: 13.3,
    y2: 181.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 25.4,
    y1: 181.9,
    x2: 672.8,
    y2: 181.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 678.9,
    y1: 181.9,
    x2: 684.9,
    y2: 181.9
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 59.7,
    y1: 126.2,
    x2: 65.7,
    y2: 126.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 77.7,
    y1: 126.2,
    x2: 672.9,
    y2: 126.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 678.9,
    y1: 126.2,
    x2: 684.9,
    y2: 126.2
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 75.6,
    y1: 31.8,
    x2: 75.6,
    y2: 37.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 75.6,
    y1: 49.7,
    x2: 75.6,
    y2: 211.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 75.6,
    y1: 217.3,
    x2: 75.6,
    y2: 223.3
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 632.8,
    y1: 31.8,
    x2: 632.8,
    y2: 37.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 632.8,
    y1: 49.7,
    x2: 632.8,
    y2: 211.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 632.8,
    y1: 217.3,
    x2: 632.8,
    y2: 223.3
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 31.1,
    y1: 151.2,
    x2: 31.1,
    y2: 75.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 31.1,
    y1: 181.1,
    x2: 31.1,
    y2: 156.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 661.4,
    y1: 150.8,
    x2: 661.4,
    y2: 126.6
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 13.2271 117.6289)",
    className: "st2 st8 st9"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 13.2271 173.4725)",
    className: "st2 st8 st9"
  }, "B"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 667.1086 144.8551)",
    className: "st2 st8 st9"
  }, "B"), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.1,
    className: "st10",
    width: 75.6,
    height: 75.6
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 34.1303 41.4725)",
    className: "st8 st9"
  }, "A")), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.8,
    y: 181.9,
    className: "st10",
    width: 75.6,
    height: 75.6
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 666.8954 223.2598)",
    className: "st8 st9"
  }, "A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalzer);
export default __webpack_public_path__ + "static/media/balzer.d99634896214b6d563f60fb726761bc2.svg";
export { ForwardRef as ReactComponent };